/**
 * @module CardType
 */

/**
 * @enum
 * A list of card types
 * @property {string} ExplicitMessageCard - A message card type name
 * @property {string} AdaptiveCard - An adaptive card type name
 * @property {string} AdaptiveCardV2 - An adaptive card v2 type name
 */

enum CardType {
    ExplicitMessageCard = 'explicitMessageCard',
    AdaptiveCard = 'adaptiveCard',
    AdaptiveCardV2 = 'adaptiveCardV2',
    /**
     * TODO: Check for connector card and add type accordingly
     */
    //ConnectorMessage: 'connectorMessage',
}

export default CardType;
